import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {

    const oContainer = document.querySelector('.js-lookbook-container');

    if (!oContainer) {
        return;
    }

    const sliders = oContainer.querySelectorAll('[id^="js-lookbook-slider-"]');
    const arProducts = oContainer.querySelectorAll('.js-lookbook-product');
    const arProductsOpen = oContainer.querySelectorAll('.js-lookbook-products-open');
    const arSizesOpen = oContainer.querySelectorAll('.js-lookbook-sizes-open');
    const arSizeAddToBasket = oContainer.querySelectorAll('.js-add-to-basket');
    const oPopupSuccess = oContainer.querySelector('.ds-popup-success');
    const oPopupSuccessText = oPopupSuccess.querySelector('.popup__text');
    const oPopupAdmission = oContainer.querySelector('.ds-popup-admission');
    const oPopupAdmissionOffersNode = oPopupAdmission.querySelector('.ds-popup-admission-offers');
    const oPopupAdmissionForm = oPopupAdmission.querySelector('.ds-popup-admission-form');
    const oPopupAdmissionFormSubmitBtn = oPopupAdmissionForm.querySelector('.ds-popup-admission-submit');

    if (sliders.length > 0) {
        sliders.forEach((slider, i) => {
            new Swiper(slider, {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 20,
                allowTouchMove: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        allowTouchMove: false
                    }
                },
                pagination: {
                    el: `#js-lookbok-pagination-${i}`,
                    type: 'bullets',
                    clickable: true,
                    bulletActiveClass: 'm-active'
                }
            });
        });
    }

    if (arProducts.length > 0) {
        arProducts.forEach(oProduct => {
            const arSubscribeProductBtns = oProduct.querySelectorAll('.ds-popup-admission-open');
            const arProductSizes = oProduct.querySelectorAll('.js-lookbook-size[data-state="disabled"]');

            if (arSubscribeProductBtns.length > 0) {
                arSubscribeProductBtns.forEach(oBtn => {
                    oBtn.addEventListener('click', () => {
                        oPopupAdmissionOffersNode.textContent = '';

                        arProductSizes.forEach(oSize => {
                            const oCloneSize = oSize.cloneNode(true);
                            oCloneSize.classList.remove('ds-popup-admission-open');

                            oCloneSize.addEventListener('click', () => {
                                oPopupAdmissionOffersNode
                                    .querySelectorAll('.js-lookbook-size')
                                    .forEach(oItem => oItem.classList.remove('selected'));

                                oCloneSize.classList.add('selected');
                                oPopupAdmissionForm.dataset.itemId = oCloneSize.dataset.id;
                            });

                            oPopupAdmissionOffersNode.appendChild(oCloneSize);
                        });
                    });
                });
            }
        });
    }

    if (arProductsOpen.length > 0) {
        arProductsOpen.forEach(oBtn => {
            oBtn.addEventListener('click', () => {
                const oWrap = oBtn.closest('.js-lookbook-item-products');
                const oProductsWrap = oWrap.querySelector('.js-lookbook-products');

                oProductsWrap.classList.toggle('hide');
            });
        });
    }

    if (arSizesOpen.length > 0) {
        arSizesOpen.forEach(oBtn => {
            oBtn.addEventListener('click', () => {
                const oWrap = oBtn.closest('.js-lookbook-product');
                const oSizesWrap = oWrap.querySelector('.js-lookbook-sizes');

                oSizesWrap.classList.toggle('hide-offers');
            });
        });
    }

    if (arSizeAddToBasket.length > 0) {
        arSizeAddToBasket.forEach(oBtn => {
            oBtn.addEventListener('click', () => {
                const iOfferId = oBtn.dataset.id;
                const sState = oBtn.dataset.state;

                if (sState === 'selected') {
                    return;
                }

                window.BX.ajax.runComponentAction('ega:favorites', 'addToBasket',
                    {
                        mode: 'class',
                        data: { id: iOfferId },
                    })
                    .then((oResponse) => {
                        if (oResponse.status == 'success' && oResponse.data.success) {
                            $('.header-add-product').find('.header-add-product-title').html('Товар добавлен в корзину').end().slideDown();
                            setTimeout(() => { $('.header-add-product').find('.header-add-product-title').html('').end().slideUp(); }, 3000);

                            window.BX.onCustomEvent('OnBasketChange');
                            document.querySelector('span.basket-quantity').innerHTML = oResponse.data.iBasketItemsTotalCnt;

                            setTimeout(() => {
                                updateCartDataLayer();
                                addToCartDataLayer(iOfferId);
                            }, 1000);

                            oBtn.dataset.state = 'selected';
                            oBtn.title = 'В корзине';
                        }
                    })
                    .catch((oResponse) => {
                        if (oResponse.errors.length === 0) {
                            return;
                        }

                        const oError = oResponse.errors[0];
                        const sCustomErrorMsg = oError.customData[0];

                        if (sCustomErrorMsg) {
                            $('.header-add-product').find('.header-add-product-title').html(sCustomErrorMsg).end().slideDown();
                            setTimeout(() => { $('.header-add-product').find('.header-add-product-title').html('').end().slideUp(); }, 3000);
                        }
                    })
            });
        });
    }

    oPopupAdmissionFormSubmitBtn.addEventListener('click', (oEvent) => {
        oEvent.preventDefault();

        const sSubscribeEmail = oPopupAdmission.querySelector('#popup-admission-email').value;
        const oPostData = {
            sessid: window.BX.bitrix_sessid(),
            contactFormSubmit: 'Y',
            itemId: oPopupAdmissionForm.dataset.itemId,
            siteId: window.BX.message('SITE_ID'),
            manyContact: 'Y',
            contact: [{ "use": "N" }, { "user": sSubscribeEmail }]
        };

        if (!oPopupAdmission.classList.contains('error') && !empty(sSubscribeEmail)) {
            window.popupAdmission.showPreloader();

            $.post(
                oPopupAdmission.dataset.ajaxUrl,
                oPostData,
                function (sResponse) {
                    const oResponse = JSON.parse(sResponse);

                    if (oResponse.success) {
                        oPopupSuccessText.textContent = 'Как только этот размер будет в наличии, мы пришлем Вам уведомление на Ваш E-mail.';
                    }

                    if (oResponse.error) {
                        oPopupSuccessText.textContent = oResponse.message || 'Ошибка. Попробуйте позже';
                    }

                    window.popupAdmission.hidePreloader();

                    oPopupAdmission.removeAttribute('data-open');
                    oPopupSuccess.setAttribute('data-open', '');
                }
            );
        }
    });
});